export const ZIPCODE_TOKEN_RE = /^[A-Z0-9\s\-]{1,15}$/i;

/**
 * Split comma-separated PLZ string; optional spaces after commas are trimmed per token.
 * @param {string} raw
 * @returns {string[]}
 */
export function parseCommaSeparatedZipcodes(raw) {
  if (raw == null || typeof raw !== "string") {
    return [];
  }
  return raw
    .split(/[,;\n]+/)
    .map((part) => part.trim().replace(/\s+/g, ""))
    .filter((part) => part.length > 0);
}

/**
 * @param {string[]} tokens
 * @returns {boolean}
 */
export function zipcodeTokensAreUnique(tokens) {
  const seen = new Set();
  for (const token of tokens) {
    const key = token.trim().toLowerCase();
    if (seen.has(key)) {
      return false;
    }
    seen.add(key);
  }
  return true;
}

/**
 * @param {string[]} tokens
 * @returns {boolean}
 */
export function zipcodeTokensAreValid(tokens) {
  return tokens.length > 0 && tokens.every((z) => ZIPCODE_TOKEN_RE.test(z));
}
